import React, { useEffect, useState } from "react";
import style from "./Blogs.module.css";
import { Container, Row } from "react-bootstrap";
import BlogCard from "./BlogCard/BlogCard";
import useBlogs from "../../hooks/useBlogs";

const Blog = () => {
  // const [blogs, setBlogs] = useState([]);

  // useEffect(() => {
  //   fetch("allBlogs.json")
  //     .then((res) => res.json())
  //     .then((data) => setBlogs(data));
  // }, []);
  const [blogs] = useBlogs();

  console.log(blogs);
  return (
    <div className={style.blog__container}>
      <Container>
        <h2 className={style.blog__title}>
          My Personal <span>Blogs</span>
        </h2>
        <Container>
          <Row className="g-5">
            {blogs.map((blog) => (
              <BlogCard key={blog.key} blog={blog}></BlogCard>
            ))}
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default Blog;
